import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=cd88be94&scoped=true"
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"
import style0 from "./ChartPie.vue?vue&type=style&index=0&id=cd88be94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd88be94",
  null
  
)

export default component.exports